import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema } from './config';


const EditCustomer = ({ ignore_id = false, edit_id = null, dialog = false, invalidate_queries = null }) => {
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

  return (
    <EditForm title={"Customer"} initialValues={initialValues} fields={formFields} schema={schema} url={"customers"} dialog={dialog} ignore_id={ignore_id} edit_id={edit_id} invalidate_queries={invalidate_queries}>
      
     </EditForm>
  );
}

export default EditCustomer;